import { useCallback } from 'react';

import { useAnalyticsUtilities } from '../hooks/useAnalyticsUtilities';
import META from './useTrackClickedTranscriptSearch.meta';

export type UseTrackClickedTranscriptSearchParams = {
  clip_id: string;
};

export const useTrackClickedTranscriptSearch = () => {
  const { track } = useAnalyticsUtilities();

  const trackClickedTranscriptSearch = useCallback(
    (params: UseTrackClickedTranscriptSearchParams) => {
      track(META.name, params);
    },
    [track],
  );

  return { trackClickedTranscriptSearch };
};
